import React, { useState, useRef, useEffect, useContext, useCallback } from 'react'
import './css/AddItem.css'
import SideNav from './SideNav'
import TopRootDiv from './TopRootDiv';
import SherDineNav from './SherDineNav';
import UploadImg from './images/MenuReg/uploadItem.png'
import Rupee from './images/MenuReg/Rupee1.png'
import { useNavigate, useLocation } from 'react-router-dom';
import AddVarientModel from './AddVarientModel';
import Info from './images/icons/info.png';
import InfoError from './images/icons/infoRed.png';
import Tick from './images/icons/tick.png'
import Tick1 from './images/icons/tick1.png'
import Upp from './images/icons/up-arrow.png'
import Rightt from './images/icons/right-arrow.png'
import cross from './images/icons/cross.png'
import domain from './images/icons/domain.png'
import fileUpload from './images/icons/image-.png'
import rightarrow from './images/Mobile/Upload (1).png'
import uparrow from './images/Mobile/Upload.png'
// import Area from './js/areas.json'
import Editing1 from './images/MenuReg/Editing1.png'
import Redeye1 from './images/MenuReg/Redeye1.png'
import AddCombo from './images/icons/AddCombo.png'
import Minus1 from './images/icons/minu1.png'
import Select from 'react-select'
import { ToastContainer, toast } from 'react-toastify';
import { DBContext } from './DBContext'
import axios from 'axios';
import searchingLotties from './images/lotties/searchingLottie.json'
import noImage from './images/icons/depositphotos_247872612-stock-illustration-no-image-available-icon-vector.jpg'

import Lottie from "lottie-react";
import SideNavMob from './SideNavMob'
import RightNavMob from './RightNavMob'
import NavBarMobile from './Mobile/NavBar'
import io from 'socket.io-client';
import { Emitter } from '@socket.io/component-emitter';
// function AddItem() {
function AddItem() {
    // FIX FOR SOCKET.IO EMITTER BUG
    useEffect(() => {
        // Store the original emit function
        const originalEmit = Emitter.prototype.emit;

        // Create a safe version that handles corrupted callbacks
        Emitter.prototype.emit = function (event) {
            this._callbacks = this._callbacks || {};

            var args = new Array(arguments.length - 1);
            var callbacks = this._callbacks['$' + event];

            for (var i = 1; i < arguments.length; i++) {
                args[i - 1] = arguments[i];
            }

            if (callbacks) {
                // Filter out any non-function callbacks to prevent the error
                callbacks = callbacks.filter(cb => typeof cb === 'function');

                if (callbacks.length === 0) {
                    // Remove empty callback arrays to prevent memory leaks
                    delete this._callbacks['$' + event];
                    return this;
                }

                // Update the stored callbacks with only valid functions
                this._callbacks['$' + event] = callbacks;

                callbacks = callbacks.slice(0);
                for (var i = 0, len = callbacks.length; i < len; ++i) {
                    try {
                        callbacks[i].apply(this, args);
                    } catch (error) {
                        console.error('Emitter callback error:', error);
                    }
                }
            }

            return this;
        };

        return () => {
            // Restore original emit when component unmounts
            Emitter.prototype.emit = originalEmit;
        };
    }, []);

    const [categories, setCategories] = useState([]);
    const [Kitchens, setKitchens] = useState([]);
    const [company, setCompany] = useState(localStorage.getItem('Company'));
    const [loadingCate, setLoadingCate] = useState(true); // To track the loading state
    const [loadingKitchen, setLoadingKitchen] = useState(true);
    const [taxGroups, setTaxGroups] = useState()
    const api_base_url = process.env.REACT_APP_API_BASE_URL
    const { customerCode, logginedDB, sideNavState, user_Id, sideNavStateFunc, rightNavState, rightNavStateFunc } = useContext(DBContext);



    const handleGetCategories = useCallback(async () => {
        // const handleGetCategories = async () => {
        try {
            const response = await axios.get(`${api_base_url}/GetCategories/${logginedDB}`)
            if (response.status == 200) {
                const transformedData = response.data.data.map(category => ({
                    value: category.id_category,
                    label: category.Category_Name,
                }));
                // console.log("transformedData", transformedData);

                setCategories(transformedData)
            }
        } catch (error) {
            console.error("Error fetching categories:", error);
            toast.error("Something went wrong while fetching categories data.",
                {
                    className: 'custom-toast',
                    bodyClassName: 'custom-toast-container',
                    closeButtonClassName: 'custom-toast-close-button',
                    onClose: () => { }
                });
        }
    }, [api_base_url, logginedDB]);

    const [kitchenOptions, setKitchenOptions] = useState([])
    const [subKitchenOptions, setSubKitchenOptions] = useState([])
    const [foodTypeOptions, setFoodTypeOptions] = useState([])
    const [allProductsOptions, setAllProductsOptions] = useState([])

    const handleGetKitchen = useCallback(async () => {
        try {
            const response = await axios.get(`${api_base_url}/GetKitchen/${logginedDB}`)
            if (response.status == 200) {
                const transformedData = response.data.map(item => ({
                    value: item.Kitchen_id,
                    label: item.KitchenName,
                }));

                setKitchenOptions(transformedData)
            }
        } catch (error) {

        }
    }, [api_base_url, logginedDB]);

    const handleGetSubKitchen = useCallback(async (id) => {
        console.log("id", id);

        try {
            const response = await axios.get(`${api_base_url}/GetSubKitchenOfKitchen/${id}/${logginedDB}`)
            if (response.status == 200) {
                const transformedData = response.data.map(item => ({
                    value: item.Sub_Kitchen_id,
                    label: item.SubKitchenName,
                }));

                setSubKitchenOptions(transformedData)
            }
        } catch (error) {
            //(error);
        }
    }, [api_base_url, logginedDB]);

    const [area, setArea] = useState([])

    const handleGetAreas = async () => {
        try {
            const response = await axios.get(`${api_base_url}/getAreas/${logginedDB}`)
            if (response.status == 200) {
                setArea(response.data)
            }
        } catch (error) {
            //(error);
        }
    }

    const handleGetFoodType = useCallback(async () => {
        try {
            const response = await axios.get(`${api_base_url}/GetFoodType/${logginedDB}`)
            if (response.status == 200) {
                const transformedData = response.data.map(item => ({
                    value: item.FoodType_id,
                    label: item.FoodType_name,
                }));

                setFoodTypeOptions(transformedData)
            }
        } catch (error) {

        }
    }, [api_base_url, logginedDB]);

    const handleGetProducts = useCallback(async () => {
        try {
            const response = await axios.get(`${api_base_url}/GetItemReg/${logginedDB}`);
            if (response.status === 200) {
                const data = Array.isArray(response.data) ? response.data : (response.data.data || []);
                const transformed = data.map(p => ({
                    value: p.id_productReg,
                    label: p.productName
                }));
                setAllProductsOptions(transformed);
            }
        } catch (error) {
            console.error("Error fetching products for pool linking:", error);
        }
    }, [api_base_url, logginedDB]);

    const socketRef = useRef(null);

    useEffect(() => {
        if (!logginedDB) return;

        socketRef.current = io(api_base_url, { transports: ["websocket"] });


        const safeHandleGetCategories = handleGetCategories || (() => console.log("handleGetCategories not defined"));
        const safeHandleGetKitchen = handleGetKitchen || (() => console.log("handleGetKitchen not defined"));
        const safeHandleGetFoodType = handleGetFoodType || (() => console.log("handleGetFoodType not defined"));

        // Register listeners directly
        socketRef.current.on("createdCategory", (data) => {
            console.log("socketRef.current", socketRef.current);
            console.log("createdCategory event received:", data);
            safeHandleGetCategories();
        });

        socketRef.current.on("GetcreatedKitchens", () => {
            safeHandleGetKitchen();
        });

        socketRef.current.on("createdFoodType", () => {
            safeHandleGetFoodType();
        });

        const loadInitialData = async () => {
            try {
                await safeHandleGetCategories();
                await safeHandleGetKitchen();
                await handleGetAreas?.();
                await handGetTaxGroups?.();
                await safeHandleGetFoodType();
                await handleGetProducts();
            } catch (error) {
                console.error("Error loading initial data:", error);
            }
        };

        loadInitialData();

        return () => {
            if (socketRef.current) {
                socketRef.current.removeAllListeners(); // Cleans up all listeners
                socketRef.current.disconnect();
            }
        };
    }, [api_base_url, logginedDB, handleGetCategories, handleGetKitchen, handleGetFoodType, handleGetProducts]);

    const location = useLocation(null)
    const productID = location.state
    const [item, setItem] = useState({})

    const customStyles = {
        option: (provided, state) => ({
            ...provided,
            width: '100%',
            fontSize: '0.881rem',
            fontFamily: 'Nunito',
            backgroundColor: state.isSelected ? '#c8cbcf' : '#FFF',
            backgroundColor: state.isFocused ? '#c8cbcf' : '#FFF',
            color: state.isFocused ? '#000' : '#000',
            ':active': {
                ...provided[':active'],
                backgroundColor: '#c8cbcf'
            }
        }),
        input: (provided) => ({
            ...provided,
            // height: '2.5rem',
            width: '100% !important',
            fontSize: '0.881rem',
            fontFamily: 'Nunito',
            cursor: 'none',
            '&:hover': {
                cursor: 'text'
            },
            '&:focus': {
                cursor: 'default',
            },
            // display: 'none', 
            color: "#2B3034"
        }),
        valueContainer: (provided) => ({
            ...provided,
            overflow: 'hidden',
            fontSize: '0.881rem',
        }),
        indicatorSeparator: (provided, state) => ({
            ...provided,
            // display: 'none', 
        }),
        dropdownIndicator: (provided, state) => ({
            ...provided,
            height: '2.5rem', // Adjust height of dropdown indicator to match control height
            marginTop: 0, // Adjust vertical alignment if needed
        }),
        control: (provided, state) => ({
            ...provided,
            width: '100% !important',
            // height: '2.5rem',
            height: '1px',
            fontSize: '0.881rem',
            fontFamily: 'Nunito',
            height: '2.5rem',
            border: '1px solid #D5D5D5',
            borderRadius: '0.313rem',
            textAlign: 'left',
            boxShadow: 'none',
            '&:hover': {
                border: '1px solid #C6C6C6',
            },
            '&:focus': {
                outline: 'none', // Remove outline on focus
                cursor: 'default', // Remove cursor on focus
            },
        }),
        placeholder: (provided, state) => ({
            ...provided,
            fontSize: '0.881rem',
            // lineHeight: '2.5rem',
        }),
        menu: (provided, state) => ({
            ...provided,
            fontSize: '.9rem',
            textAlign: 'left',
            width: '100%',
            position: 'absolute',
            right: 0,
            left: 'auto',
        }),
        container: (provided) => ({
            ...provided,
            height: '100%',
            position: 'relative',
        }),
        menuList: (provided, state) => ({
            ...provided,
            maxHeight: '150px',
            overflowY: 'auto',
            overflowX: 'hidden',
            scrollbarWidth: 'thin',
            msOverflowStyle: 'auto',
            '&::-webkit-scrollbar': {
                width: '4px',
            },
            '&::-webkit-scrollbar-thumb': {
                background: '#c1c1c1',
                borderRadius: '4px',
            }
        }),
        menuPortal: base => ({ ...base, zIndex: 9999 })
    };

    const [selectedOption, setSelectedOption] = useState({})

    useEffect(() => {
        if (selectedOption.Kitchen) {
            const kitchenIdOrName = selectedOption.Kitchen.value
            console.log(typeof kitchenIdOrName);
            if (typeof kitchenIdOrName === "string") {
                console.log("kitchenIdOrName", kitchenIdOrName);
                (async () => {
                    try {
                        const response = await axios.get(
                            `${api_base_url}/GetKitchenName/${logginedDB}/${kitchenIdOrName}`
                        );

                        if (response.status === 200) {
                            console.log("GetKitchenName response:", response.data[0].Kitchen_id);
                            handleGetSubKitchen(response.data[0].Kitchen_id)
                        } else {
                            console.log("Failed GetKitchenName");
                        }
                    } catch (error) {
                        console.error("Error in GetKitchenName:", error);
                    }
                })();
                // const response =  axios.get(`${api_base_url}/GetKitchenName/${logginedDB}/${kitchenIdOrName}`
                //     // , {
                //     //     method: "GET",
                //     //     headers: {
                //     //         "Content-Type": "application/json",
                //     //     },
                //     //     body: JSON.stringify(kitchenIdOrName),
                //     // }
                // )
                // if (response.status == 200) {
                //     console.log(response, "GetKitchenName");

                // } else {
                //     console.log("failed GetKitchenName");

                // }
                // .then((response) => {
                //     if (response.ok) {
                //         toast.success("Category registered successfully!", {
                //             className: 'custom-toast',
                //             bodyClassName: 'custom-toast-container',
                //             closeButtonClassName: 'custom-toast-close-button',
                //             onClose: () => { }
                //         })
                //     } else {
                //         console.error("Failed to register category.");
                //     }
                // })
                // .catch((error) => console.error("Error registering category:", error));
            } else {
                handleGetSubKitchen(selectedOption.Kitchen.value)
            }
        }
    }, [api_base_url, selectedOption])

    const handleSelectField = async (value, fieldName, itemField) => {
        console.log("value", value, typeof value.value);
        // if (typeof value.value === 'string') {
        //     (async () => {
        //             try {
        //                 const name = value.value
        //                 const response = await axios.get(
        //                     `${api_base_url}/getCategoryName/${logginedDB}/${name}`
        //                 );

        //                 if (response.status === 200) {
        //                     console.log("getCategoryName response:", response.data);
        //                 } else {
        //                     console.log("Failed getCategoryName");
        //                 }
        //             } catch (error) {
        //                 console.error("Error in getCategoryName:", error);
        //             }
        //         })();
        // }
        if (!value) {
            return; // Exit if the value is null or undefined
        }

        const currentDate = new Date().toISOString().split('T')[0];

        const formatTime = () => {
            let now = new Date();
            let hours = now.getHours();
            let minutes = now.getMinutes();
            const ampm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12 || 12; // Convert 24-hour to 12-hour format
            minutes = minutes.toString().padStart(2, '0'); // Ensure two-digit minutes
            return `${hours}:${minutes} ${ampm}`;
        };

        const eventDetails = {
            ddate: currentDate,
            ttime: formatTime(),
            user_Id: user_Id, // Replace with actual user ID variable
        };
        if (fieldName === "Category") {
            const isRegistered = categories.some((category) => category.label === value.label);
            if (!isRegistered) {
                const confirmRegister = window.confirm("Not Registered. Do you want to register this category?");
                if (confirmRegister) {
                    const today = new Date();
                    const newCategory = { CategoryName: value.value || value, CategoryCode: value.label || value, Date: today };
                    setCategories((prev) => [...prev, newCategory]);
                    console.log(categories);

                    fetch(`${api_base_url}/CategoryReg/${logginedDB}/${JSON.stringify(eventDetails)}`, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify(newCategory),
                    })
                        .then((response) => {
                            if (response.ok) {
                                toast.success("Category registered successfully!", {
                                    className: 'custom-toast',
                                    bodyClassName: 'custom-toast-container',
                                    closeButtonClassName: 'custom-toast-close-button',
                                    onClose: () => { }
                                })
                            } else {
                                console.error("Failed to register category.");
                            }
                        })
                        .catch((error) => console.error("Error registering category:", error));
                } else {
                    return; // Exit if the user does not want to register
                }
            }
        } else if (fieldName === "Kitchen") {
            const isRegistered = kitchenOptions.some((kitchen) => kitchen.label === value.label);
            if (!isRegistered) {
                const confirmRegister = window.confirm("Not Registered. Do you want to register this kitchen?");
                if (confirmRegister) {
                    ;
                    const today = new Date();
                    const newKitchen = { KitchenName: value.value || value, KitchenCode: value.label || value, Date: today };
                    setKitchenOptions((prev) => [...prev, newKitchen]);

                    fetch(`${api_base_url}/KitchenReg/${logginedDB}/${JSON.stringify(eventDetails)}`, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify(newKitchen),
                    })
                        .then((response) => {
                            if (response.ok) {
                                toast.success("Kitchen registered successfully!", {
                                    className: 'custom-toast',
                                    bodyClassName: 'custom-toast-container',
                                    closeButtonClassName: 'custom-toast-close-button',
                                    onClose: () => { }
                                })
                            } else {
                                console.error("Failed to register kitchen.");
                            }
                        })
                        .catch((error) => console.error("Error registering kitchen:", error));
                } else {
                    return; // Exit if the user does not want to register
                }
            }
        } else if (fieldName === "FoodType") {
            const isRegistered = foodTypeOptions.some((type) => type.label === value.label);
            if (!isRegistered) {
                const confirmRegister = window.confirm("Not Registered. Do you want to register this foodtype?");
                if (confirmRegister) {
                    const today = new Date();
                    const newFoodType = { FoodType_name: value.value || value, Date: today };
                    setFoodTypeOptions((prev) => [...prev, newFoodType]);
                    const response = await axios.post(
                        `${api_base_url}/FoodTypeReg/${logginedDB}/${JSON.stringify(eventDetails)}`, newFoodType
                    );
                    if (response.status === 200) {
                        toast.success("footType registered successfully!", {
                            className: 'custom-toast',
                            bodyClassName: 'custom-toast-container',
                            closeButtonClassName: 'custom-toast-close-button',
                            onClose: () => { }
                        })
                    }
                } else {
                    return; // Exit if the user does not want to register
                }
            } else {
                setSelectedOption((prev) => ({
                    ...prev,
                    [fieldName]: value,
                }));
            }
        }
        setSelectedOption((prev) => ({
            ...prev,
            [fieldName]: value,
        }));
        setItemDetails((prev) => ({
            ...prev,
            [fieldName]: value,
        }));
        item[itemField] = ''; // Reset the corresponding field
    };

    const handleFocusSelect = (itemField) => {
        setItem({
            ...item,
            [itemField]: ""
        })
    }

    const FoodType = [
        { value: '1', label: 'Veg' },
        { value: '2', label: 'Non Veg' }
    ];

    const Kitchen_Options = [
        { value: '1', label: 'D' },
        { value: '2', label: 'E' },
        { value: '3', label: 'F' }
    ];

    const fileInputRef = useRef(null); // Ref for accessing file input element
    const [image, setImage] = useState(null);
    const [preview, setPreview] = useState(null);
    const [loading, setLoading] = useState(false); // State to track loading indicator
    const variantRef = useRef(null)
    const priceRef = useRef(null)
    const addonRef = useRef(null)

    const handleDivClick = () => {
        if (preview) return
        return fileInputRef.current.click();
    };

    const handleImageChange = (event, fieldName) => {
        const file = event.target.files[0];
        if (file) {
            setLoading(true); // Set loading to true when starting to load
            setImage(file);
            const reader = new FileReader();
            reader.onloadend = () => {
                setPreview(reader.result);
            };
            reader.readAsDataURL(file);
            setLoading(false);
        }
    };

    const [searchingWeb, setSearchingWeb] = useState(false)

    const handleGenerateWebImg = async (e) => {
        e.stopPropagation()
        if (!itemDetails.itemName) return alert("Item Name required!");
        setSearchingWeb(true);
        setPreview(null);
        try {
            console.log("in try 1");

            const response = await axios.get(`${api_base_url}/GetWebGeneratedImage/${itemDetails.itemName}`);
            console.log("in try 2");
            if (response.status === 200) {
                console.log("in try 200 1");
                setSearchingWeb(false);
                const base64Image = response.data.base64Image;
                const byteArray = response.data.data;
                console.log("in try 200 2");
                if (base64Image) {
                    console.log("in try 200 base64Image 1");
                    const base64 = base64Image.split(',')[1]; // Remove "data:image/x-icon;base64," prefix
                    const binaryData = atob(base64);
                    const buffer = new Uint8Array(binaryData.length);
                    console.log("in try 200 base64Image 2");
                    for (let i = 0; i < binaryData.length; i++) {
                        buffer[i] = binaryData.charCodeAt(i);
                    }
                    console.log("in try 200 base64Image 3");
                    const blob = new Blob([buffer], { type: 'image/x-icon' }); // MIME type matches the prefix in base64Image
                    if (blob.size > 0) {
                        console.log("in try 200 base64Image blob.size 1");
                        const file = new File([blob], `${itemDetails.itemName}.ico`, { type: 'image/x-icon' });
                        setPreview(URL.createObjectURL(file));
                        setImage(file);
                        console.log("in try 200 base64Image blob.size 2");
                    } else {
                        console.log("in try 200 base64Image blob.size else");
                        console.error("Blob size is zero, invalid image data.");
                    }
                } else if (byteArray) {
                    console.log("in try 200 byteArray 1");
                    const blob = new Blob([new Uint8Array(byteArray)], { type: 'image/x-icon' });
                    if (blob.size > 0) {
                        console.log("in try 200 byteArray blob.size 1");
                        console.log("in try 200 base64Image byteArray 1");
                        const file = new File([blob], `${itemDetails.itemName}.ico`, { type: 'image/x-icon' });
                        setPreview(response.data.base64Image);
                        setImage(file);
                    } else {
                        console.log("in try 200 byteArray 1");
                        console.error("Blob size is zero, invalid image data.");
                    }
                } else {
                    console.log("in try 200 byteArray else 1");
                    console.error("No valid image data found in the response.");
                }
            } else if (response.status === 500) {
                console.log("error 500");
            } else if (response.status === 501) {
                console.log("error 501 script python");
            } else {
                console.log("something else went wrong");
            }
        } catch (error) {
            console.log("");

            console.error("Error generating web image:", error);
        }
    };

    const navigate = useNavigate(null)
    const toGetBack = () => {
        navigate('/BaseMenuReg')
    }

    const [addVarient, setAddVarient] = useState(false)
    const [variantRequireError, setVariantRequireError] = useState(false)
    const [variantRequireErrorTimeOut, setVariantRequireErrorTimeOut] = useState(false)
    const parentRef = useRef(null);
    const [isHovered, setIsHovered] = useState(false);
    const [itemInfo, setItemInfo] = useState(true)
    const [itemVariant, setItemVariant] = useState(false)
    const [itemAddons, setItemAddons] = useState(false)
    const [itemPrice, setItemPrice] = useState(false)
    const handleitemInfo = () => {
        setItemInfo(true)
        setItemVariant(false)
        setItemPrice(false)
        setItemAddons(false)
    }
    const handleitemVariant = () => {
        if (!variantRequireError) {
            setItemVariant(true)
            setItemPrice(false)
            setItemAddons(false)
            setItemInfo(false)
        }
    }
    const handleitemPrice = () => {
        if (!priceRequireError) {
            setItemPrice(true)
            setItemAddons(false)
            setItemInfo(false)
            setItemVariant(false)
        }
    }
    const [buttonStandard, setButtonStandard] = useState(true)
    const [buttonVariants, setButtonVariants] = useState(false)
    const [buttonCombo, setButtonCombo] = useState(false)
    const handleButtonStandard = () => {
        setButtonStandard(true)
        setButtonVariants(false)
        setButtonCombo(false)
    }
    const handleButtonVariants = () => {
        setButtonStandard(false)
        setButtonVariants(true)
        setButtonCombo(false)
    }
    const handleButtonCombo = () => {
        setButtonStandard(false)
        setButtonVariants(false)
        setButtonCombo(true)
    }

    const [itemDetails, setItemDetails] = useState({})
    const handleOnChangeItem = (e, fieldName, itemField) => {

        const value = e.target.value
        console.log("value", value);

        setItemDetails((prev) => ({
            ...prev,
            [fieldName]: value
        }))
        item[itemField] = ''
    }

    const [priceDetails, setPriceDetails] = useState({ normalPrice: 0 })

    const handGetTaxGroups = async () => {
        try {
            const response = await fetch(`${api_base_url}/getTaxGroups/${logginedDB}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            const data = await response.json();

            const transformedData = data.map(item => ({
                value: item.id_tax,
                label: item.name
            }));
            // //("transformedData", transformedData)
            setTaxGroups(transformedData);

        } catch (error) {
            console.error('Error fetching items:', error);
        }
    };

    useEffect(() => {
        if (priceDetails.normalPrice) {
            area.forEach(area => {
                respectedAreaPrice(area.ContainerCharge, area.AreaName);
            });
        }
    }, [priceDetails.normalPrice]);


    const handleOnChangePrice = (e, fieldName) => {
        const newValue = e.target.value;

        // Validate and format the new value
        const formattedValue = formatInputValue(newValue, fieldName);

        if (fieldName === 'normalPrice') {
            // Update normalPrice in priceDetails
            setPriceDetails(prev => {

                const updatedPriceDetails = {
                    ...prev,
                    [fieldName]: !newValue ? '' : formattedValue
                };

                // Recalculate respected area prices if normalPrice is updated
                area.forEach(area => {
                    respectedAreaPrice(area.ContainerCharge, area.AreaName, newValue);
                });

                return updatedPriceDetails;
            });
        } else {

            // Update respected area price in both respectedAreaPriceState and priceDetails
            setRespectedAreaPriceState1(prev => {
                const updatedState = {
                    ...prev,
                    [fieldName]: respectedAreaPriceState1[fieldName] === '' ? 0 : newValue
                };

                // Update priceDetails with the respected area price
                setPriceDetails(prevDetails => ({
                    ...prevDetails,
                    [fieldName]: formattedValue
                }));

                return updatedState;
            });
        }
    };

    const handleOnBlurPrice = (percent, fieldName) => {
        if (respectedAreaPriceState1[fieldName] === '') {
            setRespectedAreaPriceState1((prev) => ({
                ...prev,
                [fieldName]: null
            }))
            respectedAreaPrice(percent, fieldName);
        }
    }

    const handleOnFocusPrice = (fieldName) => {
        if (fieldName === 'normalPrice') {
            if (priceDetails[fieldName] === 0) {
                setPriceDetails(prevDetails => ({
                    ...prevDetails,
                    [fieldName]: ''
                }));
            }
        }
    }

    // Function to format input value to ensure it has 2 decimal places
    const formatInputValue = (value, fieldName) => {
        // Regex to match number with up to 2 decimal places
        const regex = /^\d*(\.\d{0,2})?$/;

        // Check if the input matches the regex pattern
        if (regex.test(value)) {
            // Return the formatted value
            return value;
        } else {
            // If input is invalid, return previous value
            return priceDetails[fieldName];
        }
    };

    const [respectedAreaPriceState, setRespectedAreaPriceState] = useState({});
    const [respectedAreaPriceState1, setRespectedAreaPriceState1] = useState({});

    const respectedAreaPrice = (percent, fieldName, newValue) => {
        if (newValue === 0 || newValue === '') {
            // //("hiiii");

            setRespectedAreaPriceState(prev => {
                const updatedState = {
                    ...prev,
                    [fieldName]: 0
                };
                return updatedState;
            });
        } else {
            // //("helloooo");

            const normalPrice = parseFloat(newValue);
            if (isNaN(normalPrice)) return; // Avoid calculations if normalPrice is invalid

            const areaPercent = normalPrice * (percent / 100);
            const totalPrice = normalPrice // + areaPercent;

            setRespectedAreaPriceState(prev => {
                const updatedState = {
                    ...prev,
                    [fieldName]: Math.round(totalPrice).toFixed(2)
                };
                return updatedState;
            });
            // Update priceDetails with the respected area price
            setPriceDetails(prevDetails => ({
                ...prevDetails,
                [fieldName]: Math.round(totalPrice).toFixed(2)
            }));
        }

    };

    const [variantDetails, setVariantDetails] = useState({})
    const handleOnChangeVariant = (e, fieldName) => {
        const value = e.target.value
        setVariantDetails((prev) => ({
            ...prev,
            [fieldName]: value
        }))
    }

    const toClear = () => {

    }


    const [editingItem, setEditingItem] = useState(null);

    const [priceRequireError, setPriceRequireError] = useState(true)

    const [variant_Price, setVariant_Price] = useState([{ itemName: '', rate: '', itemPrice: 0, isAdding: true }])

    useEffect(() => {
        // //(priceDetails);

        if (priceDetails.normalPrice !== 0 && priceDetails.normalPrice !== '0'
        ) {

            setVariantRequireError(true)
        } else {

            setVariantRequireError(false)

        }
        if (variant_Price[0].itemName) {
            setPriceRequireError(true)
        } else {
            setPriceRequireError(false)

        }
    }, [itemDetails, priceDetails, variant_Price])

    // In your variant input change handler:
const handleVariantChange = (index, field, value) => {
    setVariant_Price(prev => {
        const updated = [...prev];
        
        if (field === 'rate') {
            // Store both rate and itemPrice for compatibility
            updated[index] = {
                ...updated[index],
                rate: value,
                itemPrice: parseFloat(value) || 0
            };
        } else {
            updated[index] = {
                ...updated[index],
                [field]: value
            };
        }
        
        return updated;
    });
};

    // const handleSaveSubmit = async () => {
    //     const itemName = (itemDetails.itemName || "").trim();
    //     const itemCode = (itemDetails.itemCode || "").trim();

    //     if (!itemName || !itemCode) {
    //         toast.error("Item Name and Item Code are required.", {
    //             className: 'custom-toast',
    //             bodyClassName: 'custom-toast-container',
    //             closeButtonClassName: 'custom-toast-close-button',
    //             onClose: () => { }
    //         });
    //         return;
    //     }

    //     const variantsWithNames = variant_Price.filter(variant => {
            
    //         const variantName = (variant.itemName || "").trim();
    //                     console.log(variantName);

    //         return variantName !== "";
    //     });

    //     const invalidVariantRate = variantsWithNames.find(variant => {
    //         console.log( `variant : ${variantsWithNames} \n`);
            
    //         return !variant.rate || variant.rate <= 0;
    //     });

    //     if (invalidVariantRate) {
    //         console.log(invalidVariantRate);
            
    //         toast.error("All variants must have a valid price (greater than 0).", {
    //             className: 'custom-toast',
    //             bodyClassName: 'custom-toast-container',
    //             closeButtonClassName: 'custom-toast-close-button',
    //             onClose: () => { }
    //         });
    //         return;
    //     }

    //     // 3. Check for overall pricing
    //     const isNormalPriceValid = priceDetails.normalPrice > 0;
    //     const hasValidVariants = variantsWithNames.length > 0;

    //     if (!isNormalPriceValid && !hasValidVariants) {
    //         toast.error("Item price is required. Either set a normal price or add at least one variant with name and price.", {
    //             className: 'custom-toast',
    //             bodyClassName: 'custom-toast-container',
    //             closeButtonClassName: 'custom-toast-close-button',
    //             onClose: () => { }
    //         });
    //         return;
    //     }

    //     // 4. Debug logging to see what's happening
    //     console.log("Debug - Variants with names:", variantsWithNames);
    //     console.log("Debug - Normal price:", priceDetails.normalPrice);
    //     console.log("Debug - isNormalPriceValid:", isNormalPriceValid);
    //     console.log("Debug - hasValidVariants:", hasValidVariants);

    //     try {
    //         console.log("itemDetails", itemDetails);

    //         // Create a new FormData object
    //         const formData = new FormData();
    //         // Append your data to FormData
    //         formData.append('itemDetails', JSON.stringify(itemDetails));
    //         formData.append('priceDetails', JSON.stringify(priceDetails));
    //         formData.append('variant_Price', JSON.stringify(variant_Price));
    //         formData.append('DB', JSON.stringify(logginedDB));
    //         formData.append('Company', JSON.stringify(customerCode));

    //         formData.append('file', image);

    //         const currentDate = new Date().toISOString().split('T')[0];

    //         const formatTime = () => {
    //             let now = new Date();
    //             let hours = now.getHours();
    //             let minutes = now.getMinutes();
    //             const ampm = hours >= 12 ? 'PM' : 'AM';
    //             hours = hours % 12 || 12;
    //             minutes = minutes.toString().padStart(2, '0');
    //             return `${hours}:${minutes} ${ampm}`;
    //         };

    //         const eventDetails = {
    //             ddate: currentDate,
    //             ttime: formatTime(),
    //             user_Id: user_Id,
    //         };

    //         console.log("Sending itemDetails:", itemDetails);
    //         console.log("Sending variant_Price:", variant_Price);

    //         const response = await fetch(`${api_base_url}/AddItemReg/${logginedDB}/${JSON.stringify(eventDetails)}`, {
    //             method: 'POST',
    //             body: formData,
    //         });

    //         if (response.ok) {
    //             const data = await response.json();
    //             if (data.success) {
    //                 toast.success(`Product registered.`, {
    //                     className: 'custom-toast',
    //                     bodyClassName: 'custom-toast-container',
    //                     closeButtonClassName: 'custom-toast-close-button',
    //                     onClose: () => { }
    //                 });
    //                 toGetBack();
    //             }
    //         } else if (response.status === 409) {
    //             toast.error(`Product already exists!!`, {
    //                 className: 'custom-toast',
    //                 bodyClassName: 'custom-toast-container',
    //                 closeButtonClassName: 'custom-toast-close-button',
    //                 onClose: () => { }
    //             });
    //         } else {
    //             toast.error(`Network response was not ok: ${response.statusText}`, {
    //                 className: 'custom-toast',
    //                 bodyClassName: 'custom-toast-container',
    //                 closeButtonClassName: 'custom-toast-close-button',
    //                 onClose: () => { }
    //             });
    //             console.error('Network response was not ok:', response.statusText);
    //         }
    //     } catch (error) {
    //         toast.error(`Error: ${error.message}`, {
    //             className: 'custom-toast',
    //             bodyClassName: 'custom-toast-container',
    //             closeButtonClassName: 'custom-toast-close-button',
    //             onClose: () => { }
    //         });
    //         console.error(error);
    //     }
    // }
// const handleSaveSubmit = async () => {
//     const itemName = (itemDetails.itemName || "").trim();
//     const itemCode = (itemDetails.itemCode || "").trim();

//     if (!itemName || !itemCode) {
//         alert("Item Name and Item Code are required.");
//         return;
//     }

//     // DEBUG LOG - Add this to see what data you're working with
//     console.log("=== DEBUG VARIANT DATA ===");
//     console.log("All variants:", variant_Price);
//     console.log("Normal price:", priceDetails.normalPrice);
    
//     // Filter only variants with non-empty names
//     const validVariants = variant_Price.filter(variant => {
//         const variantName = (variant.itemName || "").trim();
//         const hasName = variantName !== "";
//         console.log(`Variant ${variantName}: hasName=${hasName}, rate=${variant.rate}, rateType=${typeof variant.rate}`);
//         return hasName;
//     });

//     console.log("Valid variants (with names):", validVariants);

//     // Validate each variant has valid price
//     const invalidVariants = validVariants.filter(variant => {
//         // Convert rate to number if it's a string
//         const rate = typeof variant.rate === 'string' ? parseFloat(variant.rate) : variant.rate;
//         return !rate || rate <= 0 || isNaN(rate);
//     });

//     if (invalidVariants.length > 0) {
//         console.log("Invalid variants found:", invalidVariants);
//         alert("All variants must have a valid price (greater than 0).");
//         return;
//     }

//     // Check overall price requirements
//     const normalPrice = parseFloat(priceDetails.normalPrice) || 0;
//     const hasValidNormalPrice = normalPrice > 0;
//     const hasValidVariantPrices = validVariants.length > 0;

//     console.log("Price check:", {
//         normalPrice,
//         hasValidNormalPrice,
//         validVariantCount: validVariants.length,
//         hasValidVariantPrices
//     });

//     if (!hasValidNormalPrice && !hasValidVariantPrices) {
//         alert("Item price is required. Either set a normal price or add at least one variant with name and price.");
//         return;
//     }

//     // All validations passed, proceed with API call
//     try {
//         console.log("itemDetails", itemDetails);
        
//         // Create a new FormData object
//         const formData = new FormData();
        
//         // Ensure all rates are numbers before sending
//         const sanitizedVariants = variant_Price.map(variant => ({
//             ...variant,
//             // Convert rate to number if it's a string
//             rate: typeof variant.rate === 'string' ? 
//                   (variant.rate === "" ? 0 : parseFloat(variant.rate) || 0) : 
//                   variant.rate || 0
//         }));

//         formData.append('itemDetails', JSON.stringify(itemDetails));
//         formData.append('priceDetails', JSON.stringify({
//             ...priceDetails,
//             normalPrice: parseFloat(priceDetails.normalPrice) || 0
//         }));
//         formData.append('variant_Price', JSON.stringify(sanitizedVariants));
//         formData.append('DB', JSON.stringify(logginedDB));
//         formData.append('Company', JSON.stringify(customerCode));
//         formData.append('file', image);

//         const currentDate = new Date().toISOString().split('T')[0];

//         const formatTime = () => {
//             let now = new Date();
//             let hours = now.getHours();
//             let minutes = now.getMinutes();
//             const ampm = hours >= 12 ? 'PM' : 'AM';
//             hours = hours % 12 || 12;
//             minutes = minutes.toString().padStart(2, '0');
//             return `${hours}:${minutes} ${ampm}`;
//         };

//         const eventDetails = {
//             ddate: currentDate,
//             ttime: formatTime(),
//             user_Id: user_Id,
//         };

//         console.log("Sending data:", {
//             itemDetails,
//             priceDetails,
//             variant_Price: sanitizedVariants,
//             eventDetails
//         });
        
//         const response = await fetch(`${api_base_url}/AddItemReg/${logginedDB}/${JSON.stringify(eventDetails)}`, {
//             method: 'POST',
//             body: formData,
//         });

//         if (response.ok) {
//             const data = await response.json();
//             if (data.success) {
//                 toast.success(`Product registered.`, {
//                     className: 'custom-toast',
//                     bodyClassName: 'custom-toast-container',
//                     closeButtonClassName: 'custom-toast-close-button',
//                     onClose: () => { }
//                 });
//                 toGetBack();
//             }
//         } else if (response.status === 409) {
//             toast.error(`Product already exists!!`, {
//                 className: 'custom-toast',
//                 bodyClassName: 'custom-toast-container',
//                 closeButtonClassName: 'custom-toast-close-button',
//                 onClose: () => { }
//             });
//         } else {
//             console.error('Network response was not ok:', response.statusText);
//         }
//     } catch (error) {
//         console.error(error);
//     }
// }

const addNewVariant = () => {
    setVariant_Price(prev => [...prev, {
        itemName: '',
        rate: '',
        itemPrice: 0,
        active: false
    }]);
};

const handleSaveSubmit = async () => {
    const itemName = (itemDetails.itemName || "").trim();
    const itemCode = (itemDetails.itemCode || "").trim();

    if (!itemName || !itemCode) {
        alert("Item Name and Item Code are required.");
        return;
    }


    // Debug: Log current variant data
    console.log("Current variant data:", variant_Price);

    // Filter only variants with non-empty names
    const validVariants = variant_Price.filter(variant => {
        const variantName = (variant.itemName || "").trim();
        return variantName !== "";
    });

    console.log("Variants with names:", validVariants);

    // Check if any valid variant has invalid price
    const hasInvalidVariant = validVariants.some(variant => {
        const price = parseFloat(variant.itemPrice);
        return isNaN(price) || price <= 0;
    });

    if (hasInvalidVariant) {
        alert("All variants must have a valid price (greater than 0).");
        return;
    }

    // Check if we have either normal price or at least one valid variant
    const isNormalPriceValid = parseFloat(priceDetails.normalPrice) > 0;
    const hasValidVariants = validVariants.length > 0;

    if (!isNormalPriceValid && !hasValidVariants) {
        alert("Item price is required. Either set a normal price or add at least one variant with name and price.");
        return;
    }

    try {
        console.log("Submitting item:", {
            itemName,
            itemCode,
            normalPrice: priceDetails.normalPrice,
            validVariantsCount: validVariants.length
        });

        // Transform variant data for server - CRITICAL FIX!
        // Server expects 'itemPrice' field, not 'rate' field
        const variantDataForServer = variant_Price.map(variant => {
            // Use existing itemPrice if available, otherwise use rate
            const price = variant.itemPrice !== undefined ? 
                         variant.itemPrice : 
                         variant.rate;
            
            return {
                itemName: variant.itemName || "",
                itemPrice: parseFloat(price) || 0,
                // Add any other fields the server might need
                ...(variant.active !== undefined && { active: variant.active })
            };
        });

        console.log("Variant data for server:", variantDataForServer);

        // Create a new FormData object
        const formData = new FormData();
        
        // Append your data to FormData
        formData.append('itemDetails', JSON.stringify(itemDetails));
        formData.append('priceDetails', JSON.stringify(priceDetails));
        
        // CRITICAL: Send transformed variant data
        formData.append('variant_Price', JSON.stringify(variantDataForServer));
        
        formData.append('DB', JSON.stringify(logginedDB));
        formData.append('Company', JSON.stringify(customerCode));
        formData.append('file', image);

        const currentDate = new Date().toISOString().split('T')[0];

        const formatTime = () => {
            let now = new Date();
            let hours = now.getHours();
            let minutes = now.getMinutes();
            const ampm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12 || 12;
            minutes = minutes.toString().padStart(2, '0');
            return `${hours}:${minutes} ${ampm}`;
        };

        const eventDetails = {
            ddate: currentDate,
            ttime: formatTime(),
            user_Id: user_Id,
        };

        console.log("Final payload:", {
            itemDetails,
            priceDetails,
            variant_Price: variantDataForServer,
            eventDetails
        });

        const response = await fetch(`${api_base_url}/AddItemReg/${logginedDB}/${JSON.stringify(eventDetails)}`, {
            method: 'POST',
            body: formData,
        });

        if (response.ok) {
            const data = await response.json();
            if (data.success) {
                toast.success(`Product registered.`, {
                    className: 'custom-toast',
                    bodyClassName: 'custom-toast-container',
                    closeButtonClassName: 'custom-toast-close-button',
                    onClose: () => { }
                });
                toGetBack();
            }
        } else if (response.status === 409) {
            toast.error(`Product already exists!!`, {
                className: 'custom-toast',
                bodyClassName: 'custom-toast-container',
                closeButtonClassName: 'custom-toast-close-button',
                onClose: () => { }
            });
        } else {
            console.error('Network response was not ok:', response.statusText);
            toast.error('Failed to register product. Please try again.');
        }
    } catch (error) {
        console.error('Submission error:', error);
        toast.error('An error occurred. Please try again.');
    }
}
    const handleOnChangeValue = (e, index, item) => {
        const value = e.target.value;

        // Create a copy of the variants array
        const updatedVariant = [...variant_Price];

        // Update the respective item (itemName or itemPrice) at the given index
        updatedVariant[index] = {
            ...updatedVariant[index],
            [item]: value,
        };

        // Update the state with the modified variants array
        setVariant_Price(updatedVariant);
    };

    const [addonErrors, setAddonErrors] = useState({});
    // Function to handle adding variants
    const handleAddOrDeleteVariants = (index) => {
        // Retrieve the current addon combo
        const currentVariant = variant_Price[index];

        // Initialize errors for the current index
        const errors = { ...addonErrors };

        // Check if both itemName and itemPrice are provided
        if (currentVariant.itemName && currentVariant.itemPrice) {
            if (currentVariant.isAdding) {
                const newVariant = { itemName: '', itemPrice: '', isAdding: false };
                const updatedVariant = [...variant_Price];

                // Preserve the value of the current input fields and mark it as not adding
                updatedVariant[index] = {
                    ...updatedVariant[index],
                    isAdding: false,
                };

                updatedVariant.push({ itemName: '', itemPrice: '', isAdding: true });
                setVariant_Price(updatedVariant);
            } else {
                // Remove the item at the given index
                const updatedVariant = variant_Price.filter((variant, idx) => idx !== index);
                setVariant_Price(updatedVariant);
            }

            // Clear errors for the current index
            errors[index] = {
                itemName: !currentVariant.itemName,
                itemPrice: !currentVariant.itemPrice,
            };
            setAddonErrors(errors);
        } else {
            // Set specific errors for itemName and itemPrice
            errors[index] = {
                itemName: !currentVariant.itemName,
                itemPrice: !currentVariant.itemPrice,
            };
            setAddonErrors(errors);
        }
    };

    const handleOnBlurItemName = (index) => {
        // Get the itemName value for the specific index
        const itemName = variant_Price[index].itemName;
        const state = variant_Price[index].isAdding;

        // Check if itemName is empty
        if (itemName.length <= 0 && !state) {
            // Remove the item if itemName is empty
            const updatedVariant = variant_Price.filter((variant, idx) => idx !== index);
            setVariant_Price(updatedVariant);
        }
    };

    const [sideNav, setSideNav] = useState(false)
    const handleSideNav = (state) => {
        setSideNav(state)
    }
    const [falseState, setFalseState] = useState(null)

    const [infoVarient, setInfoVarient] = useState(false)

    return (
        <div className='w-screen h-screen xl:h-screen lg:h-full flex overflow-x-hidden'>
            <div className='w-full h-full hidden sm:flex sm:flex-col overflow-x-hidden'>
                <SherDineNav sideNav={(state) => handleSideNav(state)} falseState={falseState} />
                <div className='w-full bg-[#f5f5f5] flex gap-3 h-full'>
                    <div className='w-max h-full z-[9999]'>
                        <SideNav focus={'Menu'} state={sideNav} falseState={(state) => setFalseState(state)} />
                    </div>
                    <div className='w-full h-full flex flex-col gap-3 pr-3 pb-3'>
                        <div className="h-max">
                            <TopRootDiv image={'Menu Management'} root={['Menu Management', 'Base Menu']} section={'Add Item'} />
                        </div>
                        <div className='h-full w-full flex flex-col bg-[#fff] gap-0 rounded-t-[.313rem]'>
                            <div className='w-full h-max flex text-center font-nunito font-[600] rounded-t-[.313rem]'>
                                <div className={`w-1/3 p-[1rem] borderItem cursor-pointer flex justify-center items-center rounded-tl-[.313rem] ${itemInfo ? 'bg-[#0008B4] text-[#fff]' : ""}`} onClick={handleitemInfo}>Details</div>
                                <div className={`w-1/3 p-[1rem] borderItem cursor-pointer flex justify-center items-center ${itemPrice ? 'bg-[#0008B4] text-[#fff]' : priceRequireError ? "text-[rgba(0,0,0,0.5)]" : ""}`} onClick={handleitemPrice}>Price</div>
                                <div className={`w-1/3 p-[1rem] borderItem cursor-pointer flex justify-center items-center rounded-tr-[.313rem] gap-2 relative ${itemVariant ? 'bg-[#0008B4] text-[#fff]' : variantRequireError ? "text-[rgba(0,0,0,0.5)]" : ""}`} onClick={handleitemVariant}>
                                    <span>Modifiers/Variant</span>
                                    {
                                        variantRequireError && (
                                            <div className='absolute flex justify-center items-center transform translate-x-[500%]'>
                                                <div className='flex justify-center items-center relative'>
                                                    <img className='w-[1rem] opacity-75 cursor-pointer' src={Info} alt=""
                                                        onMouseEnter={() => setInfoVarient(true)}
                                                        onMouseLeave={() => setInfoVarient(false)} />
                                                    {infoVarient && (
                                                        <div className='absolute w-[10rem] h-max text-[#000] bg-[#fff] text-[.9rem] font-[500] transform translate-y-[90%] right-0 p-2 shadow-md border rounded-md'>
                                                            Please fill the required Info
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                            {itemInfo && (
                                <div className='p-3 w-full h-full flex flex-col gap-3'>
                                    <div className='flex w-full h-max'>
                                        <div className='MenuAddItem_itemInfo_TitleDivHead'>
                                            <span className='itemInfo_TitleDivHeadSpan'>Item Info</span>
                                        </div>
                                        <div className='MenuAddItem_itemInfo_TitleDivTail font-[600]'>
                                            <button className='loginBorder bg-[#fff] text-[#0008B4] rounded-[.313rem] pl-4 pr-4 pt-[.25rem] pb-[.25rem]' onClick={toGetBack}>Cancel</button>
                                            <button className='loginBorder bg-[#0008B4] text-[#fff] rounded-[.313rem] pl-4 pr-4 pt-[.25rem] pb-[.25rem]' onClick={handleSaveSubmit}>Save</button>
                                        </div>
                                    </div>
                                    <div className='w-full h-full flex'>
                                        <div className='w-max h-max flex flex-col justify-center items-center gap-3 pt-3'>
                                            <div className='w-[14.8rem] h-[14.8rem] flex justify-center items-center borderDashed rounded-[.313rem]' onClick={handleDivClick}>
                                                <input
                                                    type="file"
                                                    ref={fileInputRef}
                                                    style={{ display: 'none' }}
                                                    onChange={(e) => handleImageChange(e, 'itemImage')}
                                                />
                                                {(loading || searchingWeb) ? (
                                                    loading ? <div className='loading-indicator'>Uploading...</div> :
                                                        searchingWeb ? <Lottie animationData={searchingLotties} loop={true} /> : null
                                                ) : preview ? (
                                                    <div className='w-full h-full relative'>
                                                        <img className='w-full h-full rounded-[.313rem]' src={preview && !preview.includes("undefined") ? preview : noImage} alt="Uploaded" />
                                                        <div className='absolute top-0 right-0 p-1 rounded-bl-[.313rem] rounded-tr-[.313rem] bg-[#fff] cursor-pointer' onClick={(e) => {
                                                            e.stopPropagation()
                                                            setPreview(null)
                                                            setImage(null)
                                                        }}>
                                                            <img className='w-[1rem]' src={cross} alt="" />
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className='flex flex-col justify-center items-center gap-2 text-[.75rem]'>
                                                        <img className={`w-[2rem]`} src={UploadImg} alt="Upload Image" />
                                                        <span className='text-center mt-2'>Drag your file here
                                                            {/* <br /> Or */}
                                                        </span>
                                                        <button className='border rounded-[.313rem] px-3 py-1' onClick={(e) => handleGenerateWebImg(e)}>Browse Web</button>
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        <div className='flex w-full flex-col pl-3 pb-3 xl:pt-2 lg:pt-1 pt-2 font-nunito text-[1rem] xl:gap-3 lg:gap-1 gap-3 h-full'>
                                            <div className='flex w-full gap-1'>
                                                <div className='flex flex-col w-1/2 text-left gap-1'>
                                                    <span>Item Name</span>
                                                    <input className='p-2 h-[2.5rem]' type="text"
                                                        // className={variantRequireErrorTimeOut ? "varientErrorColor" : ""}
                                                        value={itemDetails.itemName}
                                                        // disabled={savedItemDetailStateManage}
                                                        onChange={(e) => handleOnChangeItem(e, 'itemName', 'productName')} />
                                                </div>
                                                <div className='flex flex-col w-1/2 text-left gap-1'>
                                                    <span>Item Code</span>
                                                    <input className='p-2 h-[2.5rem]' type="text"
                                                        // className={variantRequireErrorTimeOut ? "varientErrorColor" : ""}
                                                        value={itemDetails.itemCode}
                                                        // disabled={savedItemDetailStateManage}
                                                        onChange={(e) => handleOnChangeItem(e, 'itemCode', 'itemCode')} />
                                                </div>
                                               
                                            </div>

                                            <div className='flex w-full gap-1'>

                                                <div className="flex flex-col w-1/3 text-left gap-1">
                                                    <span>Select Category</span>
                                                    <Select
                                                        // styles={customStyles}
                                                        value={itemDetails.Category}
                                                        inputValue={itemDetails.category}
                                                        onFocus={() => handleFocusSelect('category')}
                                                        onChange={(val) => handleSelectField(val, "Category", "category")} // All logic is now centralized
                                                        options={categories}
                                                        // isClearable
                                                        isSearchable
                                                        noOptionsMessage={({ inputValue }) =>
                                                            inputValue ? `No options for "${inputValue}". Press Enter to add.` : "No options available."
                                                        }
                                                        onInputChange={(inputValue) => {
                                                            setItemDetails((prev) => (
                                                                console.log("inputValue", inputValue),
                                                                {
                                                                    ...prev,
                                                                    category: inputValue, // Track the typed value
                                                                }));
                                                        }}
                                                        onKeyDown={(event) => {
                                                            if (event.key === "Enter" && itemDetails.category) {
                                                                const inputValue = itemDetails.category.trim();
                                                                const newCategory = { value: inputValue, label: inputValue };
                                                                handleSelectField(newCategory, "Category", "category");
                                                            }
                                                        }}
                                                    />
                                                </div>

                                                <div className="flex flex-col w-1/3 text-left gap-1">
                                                    <span>Kitchen Select</span>
                                                    <Select
                                                        // styles={customStyles}
                                                        value={selectedOption.Kitchen}
                                                        inputValue={itemDetails.kitchen} // Track the typed value for kitchen
                                                        onFocus={() => handleFocusSelect('kitchen')}
                                                        onChange={(val) => handleSelectField(val, "Kitchen", "kitchen")} // All logic is centralized
                                                        options={kitchenOptions}
                                                        // isClearable
                                                        isSearchable
                                                        noOptionsMessage={({ inputValue }) =>
                                                            inputValue ? `No options for "${inputValue}". Press Enter to add.` : "No options available."
                                                        }
                                                        onInputChange={(inputValue) => {
                                                            setItemDetails((prev) => ({
                                                                ...prev,
                                                                kitchen: inputValue, // Track the typed value for kitchen
                                                            }));
                                                        }}
                                                        onKeyDown={(event) => {
                                                            if (event.key === "Enter" && itemDetails.kitchen) {
                                                                const inputValue = itemDetails.kitchen.trim();
                                                                const newKitchen = { value: inputValue, label: inputValue };
                                                                handleSelectField(newKitchen, "Kitchen", "kitchen");
                                                            }
                                                        }}
                                                    />
                                                </div>
                                                <div className='flex flex-col w-1/3 text-left gap-1'>
                                                    <span>Select Food Type</span>
                                                    <Select
                                                        // styles={customStyles}
                                                        value={selectedOption.FoodType}
                                                        inputValue={itemDetails.foodType || ''} // Track the typed value for kitchen
                                                        onFocus={() => handleFocusSelect('foodType')}
                                                        onChange={(val) => handleSelectField(val, "FoodType", "foodType")} // All logic is centralized
                                                        options={foodTypeOptions}
                                                        // // isClearable
                                                        isSearchable
                                                        noOptionsMessage={({ inputValue }) =>
                                                            inputValue ? `No options for "${inputValue}". Press Enter to add.` : "No options available."
                                                        }
                                                        onInputChange={(inputValue) => {
                                                            setItemDetails((prev) => ({
                                                                ...prev,
                                                                foodType: inputValue, // Track the typed value for kitchen
                                                            }));
                                                        }}
                                                        onKeyDown={(event) => {
                                                            if (event.key === "Enter" && itemDetails.foodType) {
                                                                const inputValue = itemDetails.foodType.trim();
                                                                const newFoodType = { value: inputValue, label: inputValue };
                                                                handleSelectField(newFoodType, "FoodType", "foodType");
                                                            }
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className='flex w-full gap-1 h-full '>
                                                <div className='flex flex-col w-1/3 text-left gap-1'>
                                                    <span>Sub Kitchen </span>
                                                    <Select
                                                        // styles={customStyles}
                                                        value={selectedOption.subKitchen}
                                                        // inputValue={item.kitchen}
                                                        onFocus={() => handleFocusSelect('subKitchen')}
                                                        onChange={(val) => handleSelectField(val, 'subKitchen', 'subKitchen')}
                                                        options={subKitchenOptions}
                                                    />
                                                </div>

                                                <div className='flex flex-col w-1/3 text-left gap-1'>
                                                    <span>Select Tax</span>
                                                   
                                                    <Select
                                                        // styles={customStyles}
                                                        value={itemDetails.tax}
                                                        onFocus={() => handleFocusSelect('tax')}
                                                        onChange={(val) => handleSelectField(val, 'tax', 'tax')}
                                                        options={taxGroups}
                                                        menuPortalTarget={document.body}
                                                        menuPosition="fixed"
                                                        menuPlacement="auto"
                                                    />
                                                </div>

                                                <div className='flex flex-col w-1/3 text-left gap-1'>
                                                    <span>Daily Production Pool Link</span>
                                                    <Select
                                                        value={itemDetails.production_link_item_id || null}
                                                        onChange={(val) => handleSelectField(val, 'production_link_item_id', 'production_link_item_id')}
                                                        options={allProductsOptions}
                                                        isClearable
                                                        isSearchable
                                                        placeholder="Select product..."
                                                        menuPortalTarget={document.body}
                                                        menuPosition="fixed"
                                                        menuPlacement="auto"
                                                    />
                                                </div>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            )}
                            {itemVariant && (
                                <div className='p-3 w-full h-full flex flex-col gap-3' ref={variantRef}>
                                    <div className='MenuAddItem_itemInfo_Title h-max'>
                                        <div className='MenuAddItem_itemInfo_TitleDivHead'>
                                            <span className='itemInfo_TitleDivHeadSpan'>{itemDetails.itemName}</span>
                                        </div>
                                        <div className='MenuAddItem_itemInfo_TitleDivTail font-[600]'>
                                            <button className='loginBorder bg-[#fff] text-[#0008B4] rounded-[.313rem] pl-4 pr-4 pt-[.25rem] pb-[.25rem]' onClick={toGetBack}>Cancel</button>
                                            <button className='loginBorder bg-[#0008B4] text-[#fff] rounded-[.313rem] pl-4 pr-4 pt-[.25rem] pb-[.25rem]' onClick={handleSaveSubmit}>Save</button>
                                        </div>
                                    </div>
                                    <div className='flex flex-col w-full h-full font-nunito'>
                                        <div className='w-full h-max flex rounded-t-[.313rem] text-center bg-[#dbdbdb] text-[1rem] font-[600]'>
                                            <div className='w-4/12 text-left p-3'>Variant</div>
                                            <div className='w-4/12 p-3'>Price</div>
                                            <div className='w-2/12 p-3'>Active</div>
                                            <div className='w-2/12 p-3'>Action</div>
                                        </div>
                                        <div className='w-full h-full flex flex-col'>
                                            {variant_Price.map((variant, index) => (
                                                <div className='flex w-full'>
                                                    <div className='w-4/12 p-3'>
                                                        <input className={`w-full borderBottem ${addonErrors[index]?.itemName ? 'AddonFieldError' : ''}`} type="text"
                                                            value={variant.itemName}
                                                            onBlur={() => handleOnBlurItemName(index)}
                                                            onChange={(e) => handleOnChangeValue(e, index, 'itemName')} 
                                                        />
                                                    </div>
                                                    <div className='w-4/12 p-3'>
                                                        <input className={`w-full borderBottem ${addonErrors[index]?.itemPrice ? 'AddonFieldError' : ''}`} type="number"
                                                            value={variant.itemPrice}
                                                            onBlur={() => handleOnBlurItemName(index)}
                                                            onChange={(e) => handleOnChangeValue(e, index, 'itemPrice')} />
                                                    </div>
                                                    <div className='w-2/12 p-3 flex justify-center items-center'>
                                                        <button>Active</button>
                                                    </div>
                                                    <div className='w-2/12 p-3 flex justify-center items-center'>
                                                        <img className='w-[1.25rem] cursor-pointer' src={variant.isAdding ? AddCombo : Minus1} alt=""
                                                            onClick={() => handleAddOrDeleteVariants(index)} />
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            )}
                            {itemPrice && (
                                <div className='w-full h-full flex flex-col' ref={priceRef}>
                                    <div className='flex flex-col'>
                                        <div className='flex flex-col gap-3 p-3'>
                                            <div className='MenuAddItem_itemInfo_Title'>
                                                <div className='MenuAddItem_itemInfo_TitleDivHead'>
                                                    <span className='itemInfo_TitleDivHeadSpan'>How do you want to price this item?</span>
                                                </div>
                                                <div className='MenuAddItem_itemInfo_TitleDivTail font-[600]'>
                                                    <button className='loginBorder bg-[#fff] text-[#0008B4] rounded-[.313rem] pl-4 pr-4 pt-[.25rem] pb-[.25rem]' onClick={toGetBack}>Cancel</button>
                                                    <button className='loginBorder bg-[#0008B4] text-[#fff] rounded-[.313rem] pl-4 pr-4 pt-[.25rem] pb-[.25rem]' onClick={handleSaveSubmit}>Save</button>
                                                </div>
                                            </div>
                                            <div className='itemInfo_PriceDiv_OPtionsDiv'>
                                                <div className={`itemInfo_PriceDiv_OPtionsDivOptions ${buttonStandard ? 'ButtonActive' : ''}`} onClick={handleButtonStandard}>
                                                    {buttonStandard && (
                                                        <img className='itemInfo_PriceDiv_OPtionsDivOptions_Image' src={Tick} alt="" />
                                                    )}
                                                    <span className='itemInfo_PriceDiv_OPtionsDivOptionsSpan'>Standard item with no customizations</span>
                                                </div>
                                                <div className={`itemInfo_PriceDiv_OPtionsDivOptions ${buttonVariants ? 'ButtonActive' : ''}`} onClick={handleButtonVariants}>
                                                    {buttonVariants && (
                                                        <img className='itemInfo_PriceDiv_OPtionsDivOptions_Image' src={Tick} alt="" />
                                                    )}
                                                    <span className='itemInfo_PriceDiv_OPtionsDivOptionsSpan'>Item has Modifiers/Variants/Customizations</span>
                                                </div>
                                                <div className={`itemInfo_PriceDiv_OPtionsDivOptions ${buttonCombo ? 'ButtonActive' : ''}`} onClick={handleButtonCombo}>
                                                    {buttonCombo && (
                                                        <img className='itemInfo_PriceDiv_OPtionsDivOptions_Image' src={Tick} alt="" />
                                                    )}
                                                    <span className='itemInfo_PriceDiv_OPtionsDivOptionsSpan'>This is a combo item</span>
                                                </div>
                                            </div>
                                        </div>
                                        {(buttonStandard || buttonVariants) && (
                                            <div className='flex w-full gap-3 p-3'>
                                                <div className='flex flex-col gap-3'>
                                                    <div className='itemInfo_PriceDiv_Sections_title'>Normal Price</div>
                                                    <div className='itemInfo_PriceDiv_Sections_PriceDiv'>
                                                        <div className='itemInfo_PriceDiv_Sections_PriceDivImage_Div'>
                                                            <img className='itemInfo_PriceDiv_Sections_PriceDivImage_Div_Image' src={Rupee} alt="" />
                                                        </div>
                                                        <input
                                                            className='itemInfo_PriceDiv_Sections_PriceDiv_Input'
                                                            type="number"
                                                            value={priceDetails.normalPrice}
                                                            onChange={(e) => handleOnChangePrice(e, 'normalPrice')}
                                                            onFocus={() => handleOnFocusPrice('normalPrice')}
                                                        />
                                                    </div>
                                                </div>
                                                {area.map((area, index) => (
                                                    <div className='flex flex-col gap-3' key={index}>
                                                        <div className='itemInfo_PriceDiv_Sections_title'>{area.AreaName} </div>
                                                        <div className='itemInfo_PriceDiv_Sections_PriceDiv'>
                                                            <div className='itemInfo_PriceDiv_Sections_PriceDivImage_Div'>
                                                                <img className='itemInfo_PriceDiv_Sections_PriceDivImage_Div_Image' src={Rupee} alt="" />
                                                            </div>
                                                            <input
                                                                className='itemInfo_PriceDiv_Sections_PriceDiv_Input'
                                                                type="number"
                                                                value={respectedAreaPriceState1[area.AreaName] ? respectedAreaPriceState1[area.AreaName] :
                                                                    (respectedAreaPriceState1[area.AreaName] === '' || respectedAreaPriceState1[area.AreaName] === 0) ? '' :
                                                                        respectedAreaPriceState[area.AreaName]}
                                                                onChange={(e) => handleOnChangePrice(e, area.AreaName)}
                                                                onBlur={() => handleOnBlurPrice(area.ContainerCharge, area.AreaName)}
                                                            />
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AddItem
